// @flow
import { pickBy, keys } from 'lodash';

export type User = {
  email: string,
  firstName: string,
  lastName: string,
  website: string,
  companyName: string,
  phoneNumber: string,
  lastNameKana: string,
  firstNameKana: string,
};

const defaultValues = {
  email: '',
  avatar: null,
  firstName: '',
  lastName: '',
  firstNameKana: '',
  lastNameKana: '',
  phoneNumber: '',
  companyName: '',
  position: '',
};

export const defaultChangePasswordValues = {
  newPassword: '',
  passwordConfirmation: '',
  currentPassword: '',
};

export const informationSource = {
  search: 0,
  event: 1,
  introduction: 2,
  advertisement: 3,
  sns: 4,
  fundinno: 5,
  stockholder: 6,
  other: 10,
};

export const strengthName = (strength: number) => {
  switch (strength) {
    case 1:
      return 'weak';
    case 2:
      return 'normal';
    case 3:
      return 'strong';
    default:
      return 'default';
  }
};

export const levelPasswordStrength = (password: string) => {
  const rules = [
    { test: text => /[a-z]/.test(text) && /[A-Z]/.test(text) },
    { test: text => /[a-z]/.test(text) || /[A-Z]/.test(text) },
    { test: text => /[0-9]/.test(text) },
  ];
  const { length } = password;
  const strength = rules
    .map(text => text.test(password))
    .filter(v => v === true).length;
  if (length > 5 && length < 129 && strength > 2) {
    switch (true) {
      case length > 9 && strength > 2:
        return 3;
      case length > 7 && strength > 2:
        return 2;
      default:
        return 1;
    }
  } else {
    return 0;
  }
};

const userValues = (values, attrs) => ({
  ...pickBy(values, (v, k) => attrs.includes(k)),
  companyName: values.members.find(m => m.companyId === values.currentCompanyId)
    .companyName,
  position: values.members.find(m => m.companyId === values.currentCompanyId)
    .position,
});

export const filterValues = (values: Object) => {
  if (values) return userValues(values, keys(defaultValues));
  return defaultValues;
};
